import { FC } from "react";
import { useMatomo } from "@/hooks/useMatomo.ts";

const MATOMO_URL = "https://matomo.kbs.de";

export const MatomoTracker: FC = () => {
    useMatomo(MATOMO_URL);
    return null;
};